import AuthForm from "../components/AuthForm";
import { useAuthForm } from "../hooks/useAuthForm";

const Auth = () => {
  const {
    phone,
    code,
    inputCode,
    password,
    passwordCheck,
    inputPassword,
    passwordsMatch,
    isTimerActive,
    timer,
    isLogin,
    setPhoneValue,
    setCodeValue,
    setPasswordValue,
    setPasswordValueCheck,
    handleResendCode,
    loginToggle,
    click,
  } = useAuthForm();

  return (
    <div className="form-container">
      <AuthForm
        isLogin={isLogin}
        phone={phone}
        setPhoneValue={setPhoneValue}
        code={code}
        setCodeValue={setCodeValue}
        inputCode={inputCode}
        password={password}
        setPasswordValue={setPasswordValue}
        passwordCheck={passwordCheck}
        setPasswordValueCheck={setPasswordValueCheck}
        inputPassword={inputPassword}
        isTimerActive={isTimerActive}
        timer={timer}
        passwordsMatch={passwordsMatch}
        handleResendCode={handleResendCode}
        click={click}
        loginToggle={loginToggle}
      />
    </div>
  );
};

export default Auth;
